import { useState } from 'react';
import { useBreakpoint } from '@frontend/responsiveness';
import { useModalControl } from '@frontend/design-system';
import { useInsuranceContext } from '../providers/insurance-provider';
import { useInsuranceTabShallowStore } from '../stores';

export const useInlineReport = () => {
  const { shouldShowTuuthFairyReport } = useInsuranceContext();
  const { shouldReportOpenInLargeModeSwitch } = useInsuranceTabShallowStore('shouldReportOpenInLargeModeSwitch');
  const { modalProps, triggerProps } = useModalControl();
  const [isReportOpen, setIsReportOpen] = useState(false || shouldReportOpenInLargeModeSwitch);
  const size = useBreakpoint();
  const isMobile = size === 'xsmall' || size === 'small' || size === 'medium' || size === 'mobile';
  return {
    switchToLargeModalProps: modalProps,
    switchToLargeModalTriggerProps: shouldShowTuuthFairyReport && isMobile ? triggerProps : {},
    isReportOpen,
    setIsReportOpen,
  };
};
